import React from 'react'
import { PropsWithChildren } from "react";
import { TabListStyled } from "./PanelGroup.styles";

/**
 * 
 * Tab items wrapper. children should be TabItem components
 *  
 */
export const TabList: React.FC<PropsWithChildren> = ({ children }) => {
  return <TabListStyled>{children}</TabListStyled>;
};
